import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Box, Flex, Heading, Button } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { newBorder, white, textSecondary } from "../../../../utils/colors";
import { useTranslation } from "react-i18next";
import { useLocation, useParams, Link } from "react-router-dom";
import useThemeColors from "../../../../hooks/useThemeColors";
import useScrollToTop from "../../../../hooks/useScrollToTop";
import Invoices from "./partials/Invoices";
import UserNoAccess from "../../../../components/partials/UserNoAccess";
// import ClinicCompanyDetails from "./partials/ClinicCompanyDetails";
// import ClinicLogo from "./partials/ClinicLogo";
// import ClinicDetails from "./partials/ClinicDetails";
// import ClinicSenderIdentities from "./partials/ClinicSenderIdentities";

const PaymentsInvoices = ({ tenant }) => {
  useScrollToTop();

  // GENERAL
  const { slug } = useParams();
  // const dispatch = useDispatch();
  // const toastComponent = ToastComponent();
  const { t } = useTranslation();
  // const toast = useToast();
  const location = useLocation();

  // COLORS
  const { whiteMode, backgroundLightMode, textPrimaryMode } = useThemeColors();

  // TAB BUTTONS
  // Button details for mapping
  const buttonDetails = [
    {
      label: t("clinicSettings.clinicInfo"),
      link: `/${slug}/settings/clinic-settings`,
      isDisabled: false,
    },
    {
      label: t("clinicSettings.activeModules"),
      link: `/${slug}/settings/clinic-settings/active-modules`,
      isDisabled: false,
    },
    {
      label: t("clinicSettings.paymentsInvoices"),
      link: `/${slug}/settings/clinic-settings/payments-and-invoices`,
      isDisabled: false,
    },
    {
      label: t("clinicSettings.tenantUsers"),
      link: `/${slug}/settings/clinic-settings/users`,
      isDisabled: false,
    },
  ];

  // STATE

  //  SIDEPANELS

  // REDUX
  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  // HANDLERS

  // FETCH DATA

  // USEEFFECT

  // CHECK PERMISSIONS

  const currentTenantSlug = slug || tenant?.slug;

  // 1. Get permissions for current tenant
  const currentTenantAccess = userInfo?.tenants?.find(
    (t) => t.slug === currentTenantSlug
  );

  const hasAccess = currentTenantAccess?.permissions?.settings?.invoices;
  // const hasAccessToCreate = currentTenantAccess?.permissions?.patients?.create;

  useEffect(() => {
    // Early exit if permissions are not loaded yet
    if (!currentTenantAccess?.permissions) return;

    const perms = currentTenantAccess.permissions;

    if (perms.settings?.invoices) return; // ✅ allowed, stay on dashboard
  }, [currentTenantAccess, slug]);

  // LOGS

  return (
    <>
      {/* HELMET START */}
      <Helmet>
        <title>{t("pageTitle.paymentsInvoices")}</title>
        <meta
          name="description"
          content={t("pageDescription.paymentsInvoices")}
        />
      </Helmet>
      {/* HELMET END */}

      {/* SIDEPANELS  START */}

      {/* SIDEPANELS  END */}

      {/* MODALS START */}
      {/* MODALS END */}

      {/* MAIN START */}
      <Box w="100%" minH="100%" pt="80px">
        <Flex
          direction="column"
          w="100%"
          p={["1rem 1rem 6rem", "2rem 2rem 6rem", "2rem 2rem 6rem"]}
        >
          <Box
            w="100%"
            h="100%"
            bg={whiteMode}
            overflow="hidden"
            borderRadius="2rem"
          >
            {/* HEADER START */}
            <Flex
              w="100%"
              direction="column"
              p="0rem 2rem 1rem"
              m="0 0 0rem"
              borderBottom={`1px solid ${newBorder}`}
            >
              <Flex
                w="100%"
                align="center"
                justify="space-between"
                borderBottom={`0px solid ${newBorder}`}
                p="2rem 0rem 0.5rem"
              >
                <Heading fontSize="1.25rem" fontWeight="600">
                  {t("clinicSettings.clinicSettings")}
                </Heading>
              </Flex>

              {/* TABS */}

              <Flex w="100%" gap="1rem" m="1rem 0 0">
                {buttonDetails.map((button, index) => {
                  // Check if the current location matches the button link
                  const isActive = location.pathname === button.link;

                  return (
                    <Link to={button.link} key={index}>
                      <Button
                        variant="primary"
                        size="sm"
                        h="2.5rem"
                        px="1.5rem"
                        bg={isActive ? textPrimaryMode : backgroundLightMode}
                        color={isActive ? white : textSecondary}
                        borderRadius="1rem"
                        fontWeight="500"
                        isDisabled={button.isDisabled}
                        _hover={{
                          bg: isActive ? textPrimaryMode : "gray.100",
                          color: isActive ? white : textSecondary,
                        }}
                      >
                        {button.label}
                      </Button>
                    </Link>
                  );
                })}
              </Flex>
            </Flex>
            {/* HEADER END */}

            {/* MAIN LAYOUT START */}
            <Flex w="100%" direction="column" p="0 2rem 8rem">
              <Flex
                w="100%"
                justify="space-between"
                direction={["column", "row", "row"]}
              >
                {hasAccess ? (
                  <Flex w="100%">
                    <Invoices />
                  </Flex>
                ) : (
                  <Flex w="100%" justify="center" align="center">
                    <UserNoAccess
                      pageName={t("noAccess.invoices")}
                      p="6rem 0"
                    />
                  </Flex>
                )}
              </Flex>
            </Flex>
            {/* MAIN LAYOUT  END */}
          </Box>
        </Flex>
      </Box>
      {/* MAIN END */}
    </>
  );
};

export default PaymentsInvoices;
